import qaConfigs from './qa'

const developmentConfigs = {
  ...qaConfigs,
} as const

export default developmentConfigs
